// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/kubernetes/v1/nodes.proto (package chalk.kubernetes.v1, syntax proto3)
/* eslint-disable */

//

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/kubernetes/v1/nodes.proto.
 */
export const file_chalk_kubernetes_v1_nodes: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message chalk.kubernetes.v1.KubernetesNodeTaint
 */
export type KubernetesNodeTaint = Message<"chalk.kubernetes.v1.KubernetesNodeTaint"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: optional string value = 2;
   */
  value?: string;

  /**
   * @generated from field: string effect = 3;
   */
  effect: string;

  /**
   * @generated from field: optional int64 time_added = 4;
   */
  timeAdded?: bigint;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesNodeTaint.
 * Use `create(KubernetesNodeTaintSchema)` to create a new message.
 */
export const KubernetesNodeTaintSchema: GenMessage<KubernetesNodeTaint> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_nodes, 0);

/**
 * @generated from message chalk.kubernetes.v1.KubernetesNodeSpec
 */
export type KubernetesNodeSpec = Message<"chalk.kubernetes.v1.KubernetesNodeSpec"> & {
  /**
   * @generated from field: optional string pod_cidr = 1;
   */
  podCidr?: string;

  /**
   * @generated from field: repeated chalk.kubernetes.v1.KubernetesNodeTaint taints = 2;
   */
  taints: KubernetesNodeTaint[];

  /**
   * @generated from field: repeated string pod_cidrs = 3;
   */
  podCidrs: string[];

  /**
   * @generated from field: optional string provider_id = 4;
   */
  providerId?: string;

  /**
   * @generated from field: optional bool unschedulable = 5;
   */
  unschedulable?: boolean;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesNodeSpec.
 * Use `create(KubernetesNodeSpecSchema)` to create a new message.
 */
export const KubernetesNodeSpecSchema: GenMessage<KubernetesNodeSpec> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_nodes, 1);

/**
 * @generated from message chalk.kubernetes.v1.KubernetesNodeCondition
 */
export type KubernetesNodeCondition = Message<"chalk.kubernetes.v1.KubernetesNodeCondition"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: int64 last_heartbeat_time = 3;
   */
  lastHeartbeatTime: bigint;

  /**
   * @generated from field: int64 last_transition_time = 4;
   */
  lastTransitionTime: bigint;

  /**
   * @generated from field: optional string reason = 5;
   */
  reason?: string;

  /**
   * @generated from field: optional string message = 6;
   */
  message?: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesNodeCondition.
 * Use `create(KubernetesNodeConditionSchema)` to create a new message.
 */
export const KubernetesNodeConditionSchema: GenMessage<KubernetesNodeCondition> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_nodes, 2);

/**
 * @generated from message chalk.kubernetes.v1.KubernetesAttachedVolume
 */
export type KubernetesAttachedVolume = Message<"chalk.kubernetes.v1.KubernetesAttachedVolume"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string device_path = 2;
   */
  devicePath: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesAttachedVolume.
 * Use `create(KubernetesAttachedVolumeSchema)` to create a new message.
 */
export const KubernetesAttachedVolumeSchema: GenMessage<KubernetesAttachedVolume> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_nodes, 3);

/**
 * @generated from message chalk.kubernetes.v1.KubernetesNodeStatus
 */
export type KubernetesNodeStatus = Message<"chalk.kubernetes.v1.KubernetesNodeStatus"> & {
  /**
   * @generated from field: repeated chalk.kubernetes.v1.KubernetesNodeCondition conditions = 1;
   */
  conditions: KubernetesNodeCondition[];

  /**
   * @generated from field: repeated string volumes_in_use = 2;
   */
  volumesInUse: string[];

  /**
   * @generated from field: repeated chalk.kubernetes.v1.KubernetesAttachedVolume volumes_attached = 3;
   */
  volumesAttached: KubernetesAttachedVolume[];
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesNodeStatus.
 * Use `create(KubernetesNodeStatusSchema)` to create a new message.
 */
export const KubernetesNodeStatusSchema: GenMessage<KubernetesNodeStatus> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_nodes, 4);

/**
 * InstanceUsage is a message that represents the usage of a single instance.
 *
 * @generated from message chalk.kubernetes.v1.KubernetesNodeData
 */
export type KubernetesNodeData = Message<"chalk.kubernetes.v1.KubernetesNodeData"> & {
  /**
   * The Chalk team name that incurred the usage.
   *
   * @generated from field: string team = 1;
   */
  team: string;

  /**
   * node.Name
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * node.UID
   *
   * @generated from field: string uid = 3;
   */
  uid: string;

  /**
   * node.kubernetes.io/instance-type
   *
   * @generated from field: string instance_type = 4;
   */
  instanceType: string;

  /**
   * topology.kubernetes.io/region
   *
   * @generated from field: string region = 5;
   */
  region: string;

  /**
   * topology.kubernetes.io/zone
   *
   * @generated from field: string zone = 6;
   */
  zone: string;

  /**
   * The time that the instance was created.
   * node.CreationTimestamp.Unix()
   *
   * @generated from field: int64 creation_timestamp = 8;
   */
  creationTimestamp: bigint;

  /**
   * node.DeletionTimestamp.Unix()
   * The time that the instance was deleted. May be 0 if the instance is still running.
   *
   * @generated from field: int64 deletion_timestamp = 9;
   */
  deletionTimestamp: bigint;

  /**
   * The time that we polled the instance for usage.
   *
   * @generated from field: int64 observed_timestamp = 10;
   */
  observedTimestamp: bigint;

  /**
   * node.Labels
   *
   * @generated from field: map<string, string> labels = 11;
   */
  labels: { [key: string]: string };

  /**
   * node.Annotations
   *
   * @generated from field: map<string, string> annotations = 12;
   */
  annotations: { [key: string]: string };

  /**
   * @generated from field: string machine_id = 13;
   */
  machineId: string;

  /**
   * @generated from field: string system_uuid = 14;
   */
  systemUuid: string;

  /**
   * @generated from field: string boot_id = 15;
   */
  bootId: string;

  /**
   * @generated from field: bool unschedulable = 16;
   */
  unschedulable: boolean;

  /**
   * @generated from field: string namespace = 17;
   */
  namespace: string;

  /**
   * container.googleapis.com/instance_id
   *
   * @generated from field: string instance_id = 18;
   */
  instanceId: string;

  /**
   * @generated from field: string cluster = 19;
   */
  cluster: string;

  /**
   * @generated from field: string total_cpu = 20;
   */
  totalCpu: string;

  /**
   * @generated from field: string total_memory = 21;
   */
  totalMemory: string;

  /**
   * @generated from field: string allocatable_cpu = 22;
   */
  allocatableCpu: string;

  /**
   * @generated from field: string allocatable_memory = 23;
   */
  allocatableMemory: string;

  /**
   * @generated from field: optional chalk.kubernetes.v1.KubernetesNodeSpec spec = 24;
   */
  spec?: KubernetesNodeSpec;

  /**
   * @generated from field: optional chalk.kubernetes.v1.KubernetesNodeStatus status = 25;
   */
  status?: KubernetesNodeStatus;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesNodeData.
 * Use `create(KubernetesNodeDataSchema)` to create a new message.
 */
export const KubernetesNodeDataSchema: GenMessage<KubernetesNodeData> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_nodes, 5);

